import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { allowedCurrencies, defaultCurrency } from '../../utils/currencyTools';
import { ellipsisApi as api, ExchangeRate } from '../ellipsisApi';

export const changeCurrency = createAsyncThunk(
  'currency/change',
  async (payload: string) => {
    // Only attempt to use localStorage on the client
    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        window.localStorage.setItem('currency', payload);
      } catch {
        // noop – localStorage might be blocked
      }
    }
    return payload;
  }
);

export const loadStoredCurrency = createAsyncThunk(
  'currency/loadStoredCurrency',
  async () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        return window.localStorage.getItem('currency');
      } catch {
        return null;
      }
    }

    return null;
  }
);

interface CurrencyState {
  currencyCode: string;
  rates: ExchangeRate[];
}

const initialState: CurrencyState = {
  currencyCode: defaultCurrency,
  rates: [],
};

const currency = createSlice({
  name: 'currency',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(changeCurrency.fulfilled, (state, action) => {
      state.currencyCode = action.payload;
    });
    builder.addCase(loadStoredCurrency.fulfilled, (state, action) => {
      const storedCurrency = action.payload;

      if (storedCurrency && allowedCurrencies.includes(storedCurrency)) {
        state.currencyCode = storedCurrency;
      }
    });
    builder.addMatcher(
      api.endpoints.getExchangeRates.matchFulfilled,
      (state, { payload }) => {
        if (Array.isArray(payload)) state.rates = payload;
      }
    );
  },
});

export default currency;
